import { Navigate, useLocation } from "react-router-dom";

const CaseSensitiveRoute = ({ path, element }: any) => {
  const location = useLocation();

  if (location.pathname !== path) {
    return <Navigate to="/login" replace />;
  }

  return element;
};

export default CaseSensitiveRoute;
